/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { BundleType } from "../../resources/nls/bundle";

/**
 * Returns the aria label for the chart item
 * @param translations The translations bundle.
 * @param series The series of the item.
 * @param group The group of the item.
 * @param value The value of the item.
 * @param isSelected Whether the item is selected.
 * @param isDrillable Whether the item is drillable.
 * @param accessibleLabel The accessible label of the item.
 * @returns 
 */
export function getItemAriaLabel(
    translations: BundleType,
    series: string,
    group: string,
    value: number,
    isSelectionEnabled: boolean,
    isSelected: boolean,
    isDrillable: boolean,
    accessibleLabel?: string,
) {
    const seriesLabel = translations.chart_labelSeries();
    const groupLabel = translations.chart_labelGroup();
    const valueLabel = translations.chart_labelValue();

    const label = accessibleLabel ||  `${seriesLabel}: ${series}; ${groupLabel}: ${group}; ${valueLabel}: ${value};`
    const selectedLabel = translations.dataVisualization_stateSelected();
    const unselectedLabel = translations.dataVisualization_stateUnselected();
    const drillableLabel = translations.viz_drillable();

    return [
        label,
        isSelectionEnabled ? (isSelected ? selectedLabel: unselectedLabel) : '',
        isDrillable ? drillableLabel: ''
    ].filter(Boolean).join(' ');
}